"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var mapProductOrder = function mapProductOrder(product) {
  return {
    sku: product.sku,
    name: product.name,
    image: product.image,
    url: product.url,
    price: {
      regular: product.base_original_price,
      special: product.base_original_price !== product.price_incl_tax ? product.price_incl_tax : null
    },
    quantity: product.qty_ordered
  };
};
var _default = mapProductOrder;
exports["default"] = _default;